




















































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {FreightService, Lading} from "@/interfaces/entity";
import {LadingStore} from "@/modules/ladings/store";
import {IdMapper} from "@/interfaces/state/base";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {LadingPaymentType, LadingPickupType} from "@/enums/type";
import moment from "moment";

@Component({
  name: "LadingPrintA6"
})
export default class extends mixins(CommonMixin){
  @Prop({required: true})
  readonly ladingId!: string;
  LadingPaymentType = LadingPaymentType;
  LadingPickupType = LadingPickupType;
  moment = moment;

  get lading(): Lading {
    return LadingStore.data[this.ladingId] || LadingStore.dataCached[this.ladingId];
  }

  get freightServiceData(): IdMapper<FreightService> {
    return FreightServiceStore.data;
  }

  get totalMoney() {
    if (this.lading?.payment === LadingPaymentType.Receiver) {
      return (this.lading?.codMoney || 0) + this.lading?.totalFee;
    } else if (this.lading?.payment === LadingPaymentType.Cash) {
      return this.lading?.codMoney || 0;
    }
    return 0;
  }
}
